import { rokidTalosBaseUrl, } from "@rokid/host";
import {
  request,
  type IRequest,
  type IResult,
  type pageData,
} from "@rokid/utils";
import { UserAgreePacts} from "./talos"


//创建或修改开发者自声明协议
export const  saveDeveloperUserpact: IRequest<UserAgreePacts,null> = (data) => {
  return request({
    url: `${rokidTalosBaseUrl}/agreement/developer/saveOrUpdate`,
    method: "post",
    data,
    needToken:true
  }).then((res) => {
    return res.data || true;
  });
};




export const  getDeveloperUserpact: IRequest<null,UserAgreePacts> = (data) => {
  return request({
    url: `${rokidTalosBaseUrl}/agreement/developer/get`,
    method: "get",
    needToken:true
  }).then((res) => {
    return res.data;
  });
};